<template>
  <div class="uk-card uk-card-default uk-padding">
    <div class="uk-text-center">
      <div class="uk-margin uk-text-large">
        {{ local_page_keys.label_you_can_take_a_new_order }}
      </div>
      <div v-if="downtime.is_orders_to_work" class="uk-width-large uk-margin-auto uk-margin-top">
        <button type="button" class="uk-button uk-button-success tm-light" @click="getNewOrder()" :disabled="loading">
          {{ local_page_keys.button_get_a_new_order }}
          <span v-if="loading" class="uk-icon uk-spinner uk-margin-left" data-uk-spinner></span>
        </button>
      </div>
      <div v-else class="uk-width-large uk-margin-auto uk-margin-top">
        <button disabled class="tm-button-grey uk-button">
          {{ local_page_keys.button_no_orders_in_the_queue }}
          </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProRetouchersInactivityTimer",
  props: {
    downtime: {},
  },
  data: () => ({
    interval: null,
    local_page_keys: {},
    role: '',
    loading:false
  }),
  methods: {
    async getNewOrder() {
      let msg = this.local_page_keys.alert_are_you_sure_you_want_to_take_on_a_new_order;
      if (confirm(msg)) {
        this.loading = true;
        this.$emit('is-loading', true);
        let data;
        if (this.role === 'test-retoucher') {
          await this.$store.dispatch('order/getNewOrder', 'senior-retoucher');
        } else {
          await this.$store.dispatch("order/getNewOrder");
        }
        data = this.$store.getters["order/getNewOrder"];
        if (data.status === "ok") {
          this.$emit('retry', true);
        } else {
          this.$emit('is-loading', false);
          this.$emit('retry', true);
        }
        this.loading = false;
      }
    },
  },
  async mounted() {
    this.local_page_keys = await this.$filtergetLocalisationPage('order-downtime');
    this.role = await this.$store.getters['profile/role'];
    this.interval = setInterval(() => {
      this.$emit('retry', true);
    }, 5000);
  },
  beforeDestroy() {
     clearInterval(this.interval);
  }

}
</script>

<style></style>